import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear session storage
    sessionStorage.removeItem('access_token');
    // Redirect to login page
    navigate('/login');
  }, [navigate]);

  return null;
}
